// import pmtPic from "../assets/images/cats.jpg"
import nexGen from "../assets/images/nexgen.png"
import pmp from "../assets/images/pmp_pic.png"
import germany from "../assets/images/germany.png"
import nimbus from "../assets/images/nimbus.png"
import awsCert from "../assets/files/aws_cloud.pdf"
import kira from "../assets/images/kira.png"
// import udemyCert from "../assets/files/udemy_certificate.pdf"
import nvidiaDeepLearning from "../assets/files/NVIDIA_Getting_Started_with_Deep_Learning.pdf"
import nvidiaAICourse from "../assets/files/NVIDIA AI for All From Basics to GenAI Practice_AI for All From Basics to GenAI Practice - Course Completion Certificate.pdf"
import cloud_pract from "../assets/images/aws_cloud_practitioner.png"
import nvidia from "../assets/images/nvidia_logo.png"
export const projects = [
  {
    title: "KIRA",
    desc: "Kids Interactive Reinforcement Application (KIRA) is a AI-powered educational platform that provides gamified learning experiences for children, adapting content and activities based on their progress and preferences.",
    tags: [
      { name: "AWS", color: "orange-300" },
      { name: "AI-Agent", color: "blue-300" },
      { name: "GitHub Action", color: "white-300" },
      { name: "FastAPI", color: "blue-600" },
      { name: "NextJS", color: "yellow-300" },


    ],
    img: kira,
    link: "https://kiraclassroom.com/",
    code: "https://www.bercerita.org/",
  },
  {
    title: "Preview My Professor - San Jose State University",
    desc: "PMP is a powerful course lookup tool that reduces search time from 5 minutes to just a few seconds.",
    tags: [
      { name: "AWS Aurora RDS", color: "blue-300" },
      { name: "PostgreSQL", color: "blue-300" },
      { name: "GCP", color: "white-300" },
      { name: "CI/CD with GCP", color: "white-300" },
      { name: "Flask", color: "blue-600" },


    ],
    img: pmp,
    link: "https://www.previewmyprofessor.com/",
    code: "https://github.com/ShangchenHsieh/preview-my-professor",
  },
  {
    title: "NexGen AI",
    desc: "NextGen AI is a AI powered cover letter generator that automate the process of generation, formatting, and download.",
    tags: [
      {
        name: "Python",
        color: "blue-400",
      },
      {
        name: "openAI",
        color: "green-400",
      },
    ],
    img: nexGen,
    link: "https://nexgen-ai-cover-letter-generator-195913554814.us-central1.run.app/",
    code: "",
  },
  {
    title: "Nimbus Cloud Banking",
    desc: "A cloud banking app with account management and transactions, built on a Django backend with AWS RDS and a Vite frontend.",
    tags: [
      {
        name: "Django",
        color: "blue-300",
      },
      {
        name: "AWS RDS",
        color: "pink-400",
      },
      {
        name: "Vite",
        color: "orange-300"
      }
    ],
    img: nimbus,
    link: "https://youtu.be/sortpnx6NxI", // to be upload
    code: "https://github.com/ShangchenHsieh/nimbus-cloud-banking",
  },
  {
    title: "Germany City+",
    desc: "Germany City+ is a travel planning Dash app for exploring Germany, providing personalized recommendations using KMeans-clustering model and AI algorithms.",
    tags: [
      {
        name: "Dash",
        color: "blue-300",
      },
      {
        name: "Plotly",
        color: "pink-400",
      },
      {
        name: "Sci-kit Learn",
        color: "orange-300"
      }
    ],
    img: germany,
    link: "", // to be upload
    code: "https://github.com/ShangchenHsieh/Germany-City-Plus",
  },
];

export const certificates = [
  {
    title: "Getting Started with Deep Learning",
    issuer: "NVIDIA",
    date: "2025",
    tags: [
      { name: "Deep Learning", color: "green-400" },
      { name: "AI/ML", color: "purple-400" },
      { name: "Neural Networks", color: "blue-400" },
    ],
    img: nvidia,
    downloadLink: nvidiaDeepLearning,
    viewLink: null,
  },
  {
    title: "AI for All: From Basics to GenAI Practice",
    issuer: "NVIDIA",
    date: "2025",
    tags: [
      { name: "Artificial Intelligence", color: "purple-400" },
      { name: "Generative AI", color: "green-400" },
      { name: "Machine Learning", color: "blue-400" },
    ],
    img: nvidia,
    downloadLink: nvidiaAICourse,
    viewLink: null,
  },
  {
    title: "AWS Cloud Practitioner",
    issuer: "Amazon Web Services",
    date: "2024",
    tags: [
      { name: "AWS", color: "orange-400" },
      { name: "Cloud Computing", color: "blue-400" },
      { name: "Infrastructure", color: "green-400" },
    ],
    img: cloud_pract, // Placeholder image
    downloadLink: awsCert,
    viewLink: null,
  }
];

export const focusAreas = [
  "Backend & APIs",
  "Full-stack Development",
  "AWS / Cloud",
  "CI/CD & DevOps",
  "AI / ML Integration",
  "Databases",
];
